import DB from './DB'

const keys = {
  'storeid':'storeid',
  'productid':'productid'
}

class BridgeDB extends DB {
  constructor(array = [], options) {
    super(array, keys, options)
  }
}

export default BridgeDB